/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { getProjectProjectsProjectIdGet } from '../fn/projects/get-project-projects-project-id-get';
import { GetProjectProjectsProjectIdGet$Params } from '../fn/projects/get-project-projects-project-id-get';
import { listProjectsProjectsGet } from '../fn/projects/list-projects-projects-get';
import { ListProjectsProjectsGet$Params } from '../fn/projects/list-projects-projects-get';
import { listScenariosProjectsProjectIdScenariosGet } from '../fn/projects/list-scenarios-projects-project-id-scenarios-get';
import { ListScenariosProjectsProjectIdScenariosGet$Params } from '../fn/projects/list-scenarios-projects-project-id-scenarios-get';
import { BackendPageProjectListItemDto } from '../models/backend-page-project-list-item-dto';
import { BackendProjectDetailDto } from '../models/backend-project-detail-dto';
import { BackendScenarioItemDto } from '../models/backend-scenario-item-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiProjectsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listProjectsProjectsGet()` */
  static readonly ListProjectsProjectsGetPath = '/projects';

  /**
   * Список проектов, доступных текущему пользователю.
   *
   * Admin → все активные проекты; обычный пользователь → только свои (`author_id = current_user.account_user_id`). Пагинация limit/offset.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProjectsProjectsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProjectsProjectsGet$Response(
    params?: ListProjectsProjectsGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPageProjectListItemDto>> {
    return listProjectsProjectsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Список проектов, доступных текущему пользователю.
   *
   * Admin → все активные проекты; обычный пользователь → только свои (`author_id = current_user.account_user_id`). Пагинация limit/offset.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProjectsProjectsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProjectsProjectsGet(
    params?: ListProjectsProjectsGet$Params,
    context?: HttpContext,
  ): Observable<BackendPageProjectListItemDto> {
    return this.listProjectsProjectsGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendPageProjectListItemDto>): BackendPageProjectListItemDto => r.body),
    );
  }

  /** Path part for operation `getProjectProjectsProjectIdGet()` */
  static readonly GetProjectProjectsProjectIdGetPath = '/projects/{project_id}';

  /**
   * Детали проекта.
   *
   * 404, если проект не существует **или** недоступен текущему пользователю — наружу не различаем эти два случая, чтобы не утекала информация о существовании чужих проектов.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProjectProjectsProjectIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectProjectsProjectIdGet$Response(
    params: GetProjectProjectsProjectIdGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectDetailDto>> {
    return getProjectProjectsProjectIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Детали проекта.
   *
   * 404, если проект не существует **или** недоступен текущему пользователю — наружу не различаем эти два случая, чтобы не утекала информация о существовании чужих проектов.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProjectProjectsProjectIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectProjectsProjectIdGet(
    params: GetProjectProjectsProjectIdGet$Params,
    context?: HttpContext,
  ): Observable<BackendProjectDetailDto> {
    return this.getProjectProjectsProjectIdGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectDetailDto>): BackendProjectDetailDto => r.body),
    );
  }

  /** Path part for operation `listScenariosProjectsProjectIdScenariosGet()` */
  static readonly ListScenariosProjectsProjectIdScenariosGetPath = '/projects/{project_id}/scenarios';

  /**
   * Сценарии проекта.
   *
   * Список сценариев. Сначала идут публичные (`is_public=True`), затем по дате расчёта.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listScenariosProjectsProjectIdScenariosGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  listScenariosProjectsProjectIdScenariosGet$Response(
    params: ListScenariosProjectsProjectIdScenariosGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendScenarioItemDto>>> {
    return listScenariosProjectsProjectIdScenariosGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Сценарии проекта.
   *
   * Список сценариев. Сначала идут публичные (`is_public=True`), затем по дате расчёта.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listScenariosProjectsProjectIdScenariosGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listScenariosProjectsProjectIdScenariosGet(
    params: ListScenariosProjectsProjectIdScenariosGet$Params,
    context?: HttpContext,
  ): Observable<Array<BackendScenarioItemDto>> {
    return this.listScenariosProjectsProjectIdScenariosGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendScenarioItemDto>>): Array<BackendScenarioItemDto> => r.body),
    );
  }
}
